import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FASES } from './jornada.copy';
import { FaseResposta } from './jornada.model';

/**
 * As 6 etapas navegáveis — um `radiogroup` de verdade: `←`/`→` movem a
 * seleção, `aria-checked` diz qual está aberta na lista. Quem decide a fase
 * selecionada é o host (`selecionada`); aqui só se pede a troca.
 */
@Component({
  selector: 'mg-mapa-de-fases',
  templateUrl: './mapa-de-fases.component.html',
  styleUrls: ['./mapa-de-fases.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class MapaDeFasesComponent {
  @Input({ required: true }) fases: FaseResposta[] = [];
  @Input() faseAtual = 1;
  @Input() selecionada = 1;
  @Output() readonly selecionar = new EventEmitter<number>();

  protected readonly FASES = FASES;

  protected resposta(numero: number): FaseResposta | undefined {
    return this.fases.find(fase => fase.numero === numero);
  }

  /** "4/4 · Concluída", "1/4 · Você está aqui", "0/4 · A conquistar" — o estado em TEXTO, legível sem cor. */
  protected legenda(numero: number): string {
    const fase = this.resposta(numero);
    const aplicaveis = fase?.missoes.filter(m => m.disponivel && m.estado !== 'nao_se_aplica') ?? [];
    const concluidas = aplicaveis.filter(m => m.estado === 'concluida').length;
    const estado = fase?.concluida ? 'Concluída' : numero === this.faseAtual ? 'Você está aqui' : 'A conquistar';

    return `${concluidas}/${aplicaveis.length} · ${estado}`;
  }

  protected mover(passo: 1 | -1): void {
    const destino = Math.min(FASES.length, Math.max(1, this.selecionada + passo));

    if (destino !== this.selecionada) {
      this.selecionar.emit(destino);
    }
  }
}
